var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal-fade"}},[(_vm.$store.state.isModal)?_c('section',{staticClass:"base-modal fixed wh100 left0 top0 flex-center z999",on:{"mouseup":_vm.releaseClick}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }